<template>
  <b-card id="page-appointments" no-body class="mb-0 p-2">
    <b-card-header class="pl-0 pr-0 d-flex align-items-between">
      <b-col cols="12" md="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>

      <b-col
        cols="12"
        md="8"
        class="d-flex align-items-between justify-content-end"
      >
        <b-button
          v-if="companyGuid && canCreate"
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
        >
          <feather-icon
            aria-label="Register"
            icon="PlusIcon"
            class="mr-25"
            size="18"
          />
          <span class="text-nowrap">{{ $t(label("register")) }}</span>
        </b-button>
      </b-col>

      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>

    <section v-if="companyGuid" class="product-upcoming-search mb-1">
      <div class="product-upcoming-search__intro">
        <span class="product-upcoming-search__icon">
          <feather-icon icon="CalendarIcon" size="21" />
        </span>
        <div>
          <h5 class="mb-25">
            {{ $t("pages.productAppointments.upcoming.title") }}
          </h5>
          <small class="text-muted">
            {{ $t("pages.productAppointments.upcoming.description") }}
          </small>
        </div>
      </div>
      <div class="product-upcoming-search__controls">
        <v-select
          v-model="selectedUpcomingClient"
          :options="customers"
          label="label"
          :get-option-key="getUpcomingClientOptionKey"
          :placeholder="
            $t('pages.productAppointments.upcoming.selectClient')
          "
          :filterable="false"
          @open="onOpenUpcomingClients"
          @close="onCloseUpcomingClients"
          @search="onSearchUpcomingClients"
        >
          <template #list-footer>
            <li
              v-show="customerHasNextPage || customerLoading"
              ref="loadUpcomingClients"
              class="product-upcoming-client-loader"
            >
              {{ $t("loadingOption") }}
            </li>
          </template>
          <template #no-options>
            {{ $t("sorryOption") }}
          </template>
        </v-select>
        <b-button
          variant="primary"
          :disabled="
            !selectedUpcomingClient ||
            selectedUpcomingClient.idClient == null ||
            upcomingAppointmentsLoading
          "
          @click="loadUpcomingClientAppointments"
        >
          <feather-icon icon="SearchIcon" size="17" class="mr-25" />
          {{ $t("pages.productAppointments.upcoming.searchAction") }}
        </b-button>
      </div>
    </section>

    <Filterss
      v-if="companyGuid"
      :fields="fildsToFilters"
      :model="model"
      :select-pagination="filterSelectPagination"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
      @select-search="handleFilterSelectSearch"
      @select-load-more="handleFilterSelectLoadMore"
    />

    <div v-if="!companyGuid" class="text-center my-5">
      <b-alert show fade variant="danger">
        <h4 class="alert-heading">Seleccione una compañía</h4>
        <p>
          No se ha seleccionado ninguna compañía. Por favor, seleccione una
          compañía para ver las citas.
        </p>
      </b-alert>
    </div>

    <b-card-body v-else class="pb-0">
      <div v-if="loading">
        <b-alert show fade variant="info" class="text-center">
          <h4 class="alert-heading mb-0">
            {{ $t("pages.productAppointments.calendarLoading") }}
          </h4>
        </b-alert>
      </div>
      <div v-show="!loading">
        <full-calendar
          ref="calendar"
          v-if="calendarOptions"
          :options="calendarOptions"
        />
      </div>
      <event-modal
        :visible="showModal"
        :options="options"
        :event="currentEvent"
        :employeeOptions="employees"
        :employeeHasNextPage="employeeHasNextPage"
        :employeeLoading="employeeLoading"
        :loadMoreEmployees="loadMoreEmployees"
        :searchEmployees="searchEmployees"
        :productOptions="products"
        :productHasNextPage="productHasNextPage"
        :productLoading="productLoading"
        :loadMoreProducts="loadMoreProducts"
        :searchProducts="searchProducts"
        :customerOptions="customers"
        :customerHasNextPage="customerHasNextPage"
        :customerLoading="customerLoading"
        :loadMoreCustomers="loadMoreCustomers"
        :searchCustomers="searchCustomers"
        :listRecurrency="listRecurrency"
        :statusAppintments="statusAppintments"
        :allStatus="allStatus"
        @save="saveEvent"
        @close="resetCurrentEvent"
        @createClient="newClient"
      />
      <event-modal-client
        :visible="showModalClient"
        :options="options"
        @save="saveEventClient"
        @close="resetCurrentEventClient"
      />
      <product-upcoming-appointments-modal
        :visible="showUpcomingAppointmentsModal"
        :client="selectedUpcomingClient"
        :appointments="upcomingAppointments"
        :loading="upcomingAppointmentsLoading"
        :range-start="upcomingRangeStart"
        :range-end="upcomingRangeEnd"
        :can-edit="canEdit"
        :can-delete="canDelete"
        @close="showUpcomingAppointmentsModal = false"
        @edit="editUpcomingAppointment"
        @delete="deleteUpcomingAppointment"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BFormCheckboxGroup,
  BButton,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BTooltip,
  BAlert,
} from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import esLocale from "@fullcalendar/core/locales/es";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import CalendarSidebar from "./CalendarSidebar.vue";
import EventModal from "./EventModal.vue";
import EventModalClient from "./EventModalClient.vue";
import ProductUpcomingAppointmentsModal from "./ProductUpcomingAppointmentsModal.vue";
import vSelect from "vue-select";

import Filterss from "../components/filters/Filterss.vue";
import moment, { locale } from "moment";
import { allProducts, getProduct } from "@core/api/request/products";
import {
  allEmployeesByCompany,
  getEmployee,
} from "@core/api/request/employees";
import {
  allClientsByCompany,
  createOrEditClient,
  getClient,
} from "@core/api/request/clients";

import {
  allAppointmentsProducts,
  createOrEditAppointmentProduct,
  getAppointmentProduct,
  deleteAppointmentProduct,
} from "@core/api/request/appointmentsProducts";

import { getCatalog } from "@core/api/request/catalogs";
import {
  getParams,
  getParamsAll,
  showLoading,
  stopLoading,
} from "@core/utils/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  name: "AppointmentsTimeline",
  components: {
    BCard,
    BCardBody,
    BFormCheckboxGroup,
    BButton,
    CalendarSidebar,
    EventModal,
    EventModalClient,
    ProductUpcomingAppointmentsModal,
    vSelect,
    FullCalendar,
    Filterss,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BTooltip,
    BAlert,
  },
  directives: {
    "b-tooltip": BTooltip,
  },
  data() {
    return {
      model: "productAppointments",
      selectedEmployees: [],
      companyGuid: null,
      totalRows: null,
      currentPage: 1,
      perPage: 20000,
      isMobile: false,
      options: "",
      employees: [],
      employeeCurrentPage: 0,
      employeePerPage: 10,
      employeeTotalPages: 0,
      employeeHasNextPage: true,
      employeeLoading: false,
      employeeSearch: "",
      employeeRequestVersion: 0,
      products: [],
      productCurrentPage: 0,
      productPerPage: 10,
      productTotalPages: 0,
      productHasNextPage: true,
      productLoading: false,
      productSearch: "",
      productRequestVersion: 0,
      customers: [],
      customerCurrentPage: 0,
      customerPerPage: 10,
      customerTotalPages: 0,
      customerHasNextPage: true,
      customerLoading: false,
      customerSearch: "",
      customerRequestVersion: 0,
      selectedUpcomingClient: null,
      upcomingAppointments: [],
      upcomingAppointmentsLoading: false,
      showUpcomingAppointmentsModal: false,
      upcomingRangeStart: null,
      upcomingRangeEnd: null,
      upcomingCustomerObserver: null,
      upcomingCustomerSearchTimer: null,
      upcomingCustomerSelectOpen: false,

      listRecurrency: [],
      statusAppintments: [],
      allStatus: [],

      hasNextPage: true,
      currentView: "timeGridWeek", // Vista actual por defecto
      visibleRange: {}, // Rango visible actual
      appliedFilters: {},
      fildsToFilters: [
        {
          name: "name",
          title: "client",
          placeholder: "client",
          type: "select",
          options: [],
          visible: true,
          multiple: false,
          close: true,
        },
        {
          name: "guidProduct",
          title: "product",
          placeholder: "product",
          type: "select",
          options: [],
          visible: true,
          multiple: false,
          close: true,
        },
        {
          name: "idEmployee",
          title: "employee",
          placeholder: "employee",
          type: "select",
          options: [],
          visible: true,
          multiple: false,
          close: true,
        },
        {
          name: "date",
          title: "date",
          placeholder: "date",
          type: "range",
          config: { mode: "range" },
        },
      ],
      firstDay: "",
      lastDay: "",
      dateChanges: false,
      employeeColors: {},
      appointments: [],
      // Modal
      showModal: false,
      showModalClient: false,
      isEditing: false,
      currentEvent: {
        id: null,
        title: "",
        start: "",
        end: "",
        idEmployee: null,
        notes: "",
        client: "",
      },
      loading: false,
      isCalendarOverlaySidebarActive: true,
      calendarOptions: null,
      companyStartHour: "07:00:00",
      companyEndHour: "19:00:00",
    };
  },

  computed: {
    filterSelectPagination() {
      return {
        name: {
          hasNextPage: this.customerHasNextPage,
          loading: this.customerLoading,
        },
        guidProduct: {
          hasNextPage: this.productHasNextPage,
          loading: this.productLoading,
        },
        idEmployee: {
          hasNextPage: this.employeeHasNextPage,
          loading: this.employeeLoading,
        },
      };
    },
    canCreate() {
      return canAccess("Agenda", "creation");
    },
    canShow() {
      return canAccess("Agenda", "reading");
    },
    canEdit() {
      return canAccess("Agenda", "edition");
    },
    canDelete() {
      return canAccess("Agenda", "elimination");
    },
    // Filtrar eventos según selección
    filteredEvents() {
      // if (!Array.isArray(this.appointments) || this.appointments.length === 0) {
      //   return [];
      // }
      // return this.appointments.map(event => {
      //   const safeEvent = {
      //     ...event,
      //     idEmployee: event.idEmployee ?? 0,
      //     extendedProps: {
      //       ...(event.extendedProps || {}),
      //       clients: event.extendedProps?.clients || [],
      //       employee: event.extendedProps?.employee || 'Sin asignar'
      //     }
      //   };
      //   return {
      //     ...safeEvent,
      //     backgroundColor: this.getEmployeeColor(safeEvent.idEmployee),
      //     borderColor: this.getEmployeeColor(safeEvent.idEmployee),
      //     textColor: '#ffffff'
      //   };
      // });
    },

    // listMonth
    headerViews() {
      return this.isMobile ? "timeGridWeek" : "timeGridWeek,timeGridDay";
    },
    initialView() {
      return this.isMobile ? "timeGridDay" : "timeGridWeek";
    },
  },

  watch: {
    filteredEvents(newEvents) {
      if (this.calendarOptions) this.calendarOptions.events = newEvents;
    },

    async "$store.state.appConfig.activeCompanyGuid"(guid) {
      if (guid && guid !== "null") {
        this.companyGuid = guid;
        this.resetTenantData();
        await this.loadInitialData();
      } else {
        this.companyGuid = null;
        this.resetTenantData();
        this.appointments = [];
        this.calendarOptions = null;
      }
    },
  },

  mounted() {
    if (typeof IntersectionObserver !== "undefined") {
      this.upcomingCustomerObserver = new IntersectionObserver(
        this.infiniteScrollUpcomingClients,
      );
    }
    this.$nextTick(() => {
      if (this.$refs.calendar) {
        this.calendarApi = this.$refs.calendar.getApi();
      }
    });
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    getCalendarWeekRange(referenceDate = null) {
      const start = moment(referenceDate || undefined)
        .startOf("isoWeek")
        .startOf("day");
      const end = start.clone().endOf("isoWeek");

      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    },

    async loadInitialData() {
      if (!this.companyGuid || this.companyGuid === "null") {
        return;
      }

      let events = [];

      try {
        const { start, end } = this.getCalendarWeekRange(
          this.visibleRange.start,
        );
        events = await this.fetchCalendarEvents(start, end);
      } catch (error) {
        console.error("Error loading product appointments", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }

      this.appointments = events;
      this.setupCalendar(events);

      try {
        await Promise.all([
          this.loadEmployees({ reset: true }),
          this.loadProducts({ reset: true }),
          this.loadCustomers({ reset: true }),
          this.loadRecurrency(),
          this.loadStatus(),
        ]);
      } catch (error) {
        console.error("Error loading product appointment filters", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },

    setupCalendar(initialEvents = null) {
      if (!this.companyGuid) return;

      let prefetchedEvents = Array.isArray(initialEvents)
        ? initialEvents
        : null;

      this.calendarOptions = {
        plugins: [timeGridPlugin, dayGridPlugin, listPlugin, interactionPlugin],
        locales: [esLocale],
        locale: "es",
        timeZone: "local",
        initialView: this.initialView,
        headerToolbar: this.getHeaderToolbar(),
        slotLabelFormat: [{ hour: "2-digit", minute: "2-digit", hour12: true }],
        slotMinTime: this.companyStartHour,
        slotMaxTime: this.companyEndHour,
        slotDuration: "00:30:00",
        allDaySlot: false,
        editable: true,
        selectable: false,
        selectMirror: true,
        navLinks: true,
        height: "auto",
        eventResizableFromStart: true,
        dragScroll: true,
        eventDurationEditable: false,
        // dateClick: this.onDateClick,
        select: this.onSelect,
        eventClick: this.onEventClick,
        eventDrop: this.onEventDrop,
        // eventResize: this.onEventResize,
        events: async (fetchInfo, successCallback, failureCallback) => {
          if (!this.companyGuid || this.companyGuid === "null") {
            successCallback([]);
            return;
          }

          if (prefetchedEvents !== null) {
            const events = prefetchedEvents;
            prefetchedEvents = null;
            successCallback(events);
            return;
          }
          try {
            showLoading();
            const events = await this.fetchCalendarEvents(
              fetchInfo.start,
              fetchInfo.end,
            );
            this.appointments = events;
            successCallback(events);
          } catch (error) {
            console.error("Error fetching events:", error);
            failureCallback(error);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          } finally {
            stopLoading();
          }
        },
        viewDidMount: (viewInfo) => {
          this.currentView = viewInfo.view.type;
          this.visibleRange = {
            start: viewInfo.view.activeStart,
            end: viewInfo.view.activeEnd,
          };
        },
        datesSet: (dateInfo) => {
          this.visibleRange = {
            start: dateInfo.start,
            end: dateInfo.end,
          };

          // if (!this.appliedFilters.date) {
          //   const startStr = moment(dateInfo.start).format('YYYY-MM-DD');
          //   const endStr = moment(dateInfo.end).format('YYYY-MM-DD');
          //   this.appliedFilters.date = `${startStr} to ${endStr}`;
          // }
        },
        customButtons: {
          prev: {
            click: async () => {
              try {
                const calendarApi = this.$refs.calendar.getApi();
                calendarApi.prev();
                this.updateVisibleRange();
              } catch (error) {
                console.error("Error al actualizar citas:", error.message);
              }
            },
          },
          next: {
            click: async () => {
              try {
                const calendarApi = this.$refs.calendar.getApi();
                calendarApi.next();
                this.updateVisibleRange();
              } catch (error) {
                console.error("Error al actualizar citas:", error.message);
              }
            },
          },
        },
        eventContent: function (arg) {
          const container = document.createElement("div");
          container.style.cssText = `
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding: 4px 6px;
            box-sizing: border-box;
            font-size: 11px;
            line-height: 1.3;
            display: flex;
            flex-direction: column;
            gap: 2px;
          `;

          const titleEl = document.createElement("div");
          const titleText = String(arg.event.title || "").trim();
          titleEl.textContent = titleText || "Cita sin título";
          titleEl.style.cssText = `
            font-weight: 700;
            color: #1a1a1a;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 12px;
            margin-bottom: 2px;
          `;

          const contentEl = document.createElement("div");
          contentEl.style.cssText = `
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            width: 100%;
            box-sizing: border-box;
            color: #2c2c2c;
            font-weight: 500;
          `;

          const extended = arg.event.extendedProps || {};
          const employee = extended.employee || "Sin empleado asignado";

          const contentCust = document.createElement("div");
          contentCust.style.cssText = `
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            width: 100%;
            box-sizing: border-box;
            color: #3a3a3a;
            font-size: 10px;
          `;

          const clientsRaw = extended.clients;
          const clients = Array.isArray(clientsRaw) ? clientsRaw : [];

          const text = clients.length
            ? clients.join(", ")
            : "Sin clientes asignados";

          const contentPhone = document.createElement("div");
          contentPhone.style.cssText = `
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            width: 100%;
            box-sizing: border-box;
            color: #4a4a4a;
            font-size: 10px;
            font-style: italic;
          `;

          const clientsRawPhones = extended.clientPhone;
          const clientPhones = Array.isArray(clientsRawPhones)
            ? clientsRawPhones
            : [];

          const textPhone = clientPhones.length
            ? clientPhones.join(", ")
            : "Sin teléfono";

          contentEl.textContent = employee;
          contentCust.textContent = text;
          contentPhone.textContent = textPhone;

          container.appendChild(titleEl);
          container.appendChild(contentEl);
          container.appendChild(contentCust);
          container.appendChild(contentPhone);

          return { domNodes: [container] };
        },
      };
    },

    newClient(e) {
      this.showModal = false;
      this.showModalClient = e;
    },

    updateVisibleRange() {
      if (this.$refs.calendar) {
        const view = this.$refs.calendar.getApi().view;
        this.visibleRange = {
          start: view.activeStart,
          end: view.activeEnd,
        };

        if (this.appliedFilters.date) {
          const [startDateStr, endDateStr] =
            this.appliedFilters.date.split(" to ");

          const startMoment = moment(startDateStr).startOf("day");
          const endMoment = moment(endDateStr).startOf("day");

          const formattedStart = startMoment.format("YYYY-MM-DD HH:mm:ss");
          const formattedEnd = endMoment.format("YYYY-MM-DD HH:mm:ss");

          this.visibleRange = {
            start: formattedStart,
            end: formattedEnd,
          };
        }
      }
    },

    async fetchCalendarEvents(start, end) {
      this.loading = true;
      try {
        const param = this.chargeParams(start, end);
        const response = await allAppointmentsProducts(param);
        const data = _.get(response, "data.items", []) || [];
        return data.map((appointment) => {
          const clients = Array.isArray(appointment.clients)
            ? appointment.clients
            : [];
          return {
          title: appointment.product?.name || "",
          start: appointment.appointmentDate,
          end: appointment.endDateTime,
          idAppointment: appointment.idAppointment,
          idEmployee: appointment.idEmployee,
          notes: appointment.notes,
          guidProduct: appointment.guidProduct,
          idCatStatus: appointment.idCatStatus,
          extendedProps: {
            employee: appointment.employee?.name || "Sin asignar",
            clients: clients.map((client) =>
                client.name
                  ? `${client.name} ${client.lastName}`
                  : "Sin nombre",
              ),
            clientPhone: clients.map(
              (client) => `${client.phoneNumber || ""}`,
            ),
            clientsList: clients,
          },
          backgroundColor: this.getEmployeeColor(appointment.idEmployee),
          borderColor: this.getEmployeeColor(appointment.idEmployee),
          textColor: "#ffffff",
          };
        });
      } catch (error) {
        throw error;
      } finally {
        this.loading = false;
      }
    },

    refetchEvents() {
      if (this.$refs.calendar) {
        this.$refs.calendar.getApi().refetchEvents();
      }
    },

    async showAppointment(id, { directEdit = false } = {}) {
      showLoading();
      await getAppointmentProduct(id)
        .then(async (resp) => {
          const appointment = _.get(resp, "data");
          await this.ensureAppointmentSelectOptions(appointment);

          const appointmentClients = Array.isArray(appointment.clients)
            ? appointment.clients
            : [];
          const employeeOption = this.employees.find((item) =>
            this.sameIdentifier(item.value, appointment.idEmployee),
          );
          const productOption = this.products.find((item) =>
            this.sameIdentifier(item.value, appointment.guidProduct),
          );

          this.currentEvent = {
            idAppointment: appointment.idAppointment,
            employee:
              appointment.employee?.name || employeeOption?.label || "",
            guidProduct: productOption?.value || appointment.guidProduct,
            appointmentDate: appointment.appointmentDate || "",
            endDateTime: appointment.endDateTime || "",
            durationMinutes: appointment.durationMinutes || null,
            clients: appointmentClients.map(
              (item) =>
                this.customers.find((customer) =>
                  this.sameIdentifier(customer.idClient, item.idClient),
                ) || this.buildCustomerOption(item),
            ),

            idEmployee: employeeOption?.value ?? appointment.idEmployee ?? null,
            notes: appointment.notes || null,
            contactDetails: appointment.contactDetails,
            isRecurring: appointment.isRecurring || false,
            idCatRecurrencePattern: appointment.idCatRecurrencePattern || null,

            appointmentTimeStar: moment(appointment.appointmentDate).format(
              "HH:mm",
            ),
            appointmentTimeEnd: moment(appointment.endDateTime).format("HH:mm"),
            idCatStatus: appointment.idCatStatus,
            productAppoimnet: appointment.product,
            statusHistory: appointment.statusHistory || [],
            previousStatusName: appointment.nameStatus,
          };
          const statusName = String(appointment.nameStatus || "").toLowerCase();
          if (
            statusName === "programada" ||
            statusName === "confirmada"
          ) {
            this.currentEvent.catStatus = {
              id: appointment.idCatStatus,
              name: appointment.nameStatus,
            };
          }
          if (directEdit) {
            this.showUpcomingAppointmentsModal = false;
            this.options = 3;
            this.isEditing = true;
            this.showModal = true;
          } else {
            this.onShow(this.currentEvent);
          }
          stopLoading();
        })
        .catch((error) => {
          stopLoading();
          console.error("Error", error.message);
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        });
    },

    async loadEmployees({ reset = false } = {}) {
      if (!this.companyGuid || (!reset && (this.employeeLoading || !this.employeeHasNextPage))) {
        return;
      }

      if (reset) {
        this.employeeCurrentPage = 0;
        this.employeeHasNextPage = true;
        this.employees.splice(0, this.employees.length);
      }

      const requestedPage = reset ? 1 : this.employeeCurrentPage + 1;
      const requestVersion = ++this.employeeRequestVersion;
      const requestCompanyGuid = this.companyGuid;
      const requestSearch = this.employeeSearch;
      this.employeeLoading = true;

      try {
        const params = [
          `page,${requestedPage}`,
          `rows,${this.employeePerPage}`,
          "active,true",
          `guidCompany,${requestCompanyGuid}`,
        ];
        if (requestSearch) params.push(`name,${requestSearch}`);

        const response = await allEmployeesByCompany(getParamsAll(params));
        if (
          requestVersion !== this.employeeRequestVersion ||
          requestCompanyGuid !== this.companyGuid ||
          requestSearch !== this.employeeSearch
        ) return;

        const data = _.get(response, "data");
        const employees = Array.isArray(data?.items) ? data.items : [];
        const transformedItems = employees.map((item) => ({
          label: item.name || String(item.idEmployee),
          name: undefined,
          value: item.idEmployee,
        }));

        if (reset) {
          this.employees.splice(0, this.employees.length, ...transformedItems);
        } else {
          transformedItems.forEach((option) => {
            if (!this.employees.some((item) => this.sameIdentifier(item.value, option.value))) {
              this.employees.push(option);
            }
          });
        }
        this.updateFilterOptions("idEmployee", this.employees);
        this.employeeCurrentPage = requestedPage;
        this.employeeTotalPages =
          Number(data?.totalPages) ||
          Math.ceil((Number(data?.totalRows) || 0) / this.employeePerPage);
        this.employeeHasNextPage =
          requestedPage < this.employeeTotalPages ||
          transformedItems.length === this.employeePerPage;
      } catch (error) {
        console.error("Error loading employees:", error.message);
        if (requestVersion === this.employeeRequestVersion) {
          this.employeeHasNextPage = false;
        }
      } finally {
        if (requestVersion === this.employeeRequestVersion) {
          this.employeeLoading = false;
        }
      }
    },

    loadMoreEmployees() {
      return this.loadEmployees();
    },

    searchEmployees(query) {
      this.employeeSearch = String(query || "").trim();
      return this.loadEmployees({ reset: true });
    },

    async loadCustomers({ reset = false } = {}) {
      if (!this.companyGuid || (!reset && (this.customerLoading || !this.customerHasNextPage))) {
        return;
      }

      if (reset) {
        this.customerCurrentPage = 0;
        this.customerHasNextPage = true;
        this.customers.splice(0, this.customers.length);
      }

      const requestedPage = reset ? 1 : this.customerCurrentPage + 1;
      const requestVersion = ++this.customerRequestVersion;
      const requestCompanyGuid = this.companyGuid;
      const requestSearch = this.customerSearch;
      this.customerLoading = true;

      try {
        const params = [
          `page,${requestedPage}`,
          `rows,${this.customerPerPage}`,
          "active,true",
          `guidCompany,${requestCompanyGuid}`,
        ];
        if (requestSearch) params.push(`name,${requestSearch}`);

        const response = await allClientsByCompany(getParamsAll(params));
        if (
          requestVersion !== this.customerRequestVersion ||
          requestCompanyGuid !== this.companyGuid ||
          requestSearch !== this.customerSearch
        ) return;

        const data = _.get(response, "data");
        const items = Array.isArray(data?.items) ? data.items : [];
        const customers = items.map(this.buildCustomerOption);

        if (reset) {
          this.customers.splice(0, this.customers.length, ...customers);
        } else {
          customers.forEach((option) => {
            if (!this.customers.some((item) => this.sameIdentifier(item.idClient, option.idClient))) {
              this.customers.push(option);
            }
          });
        }
        this.updateFilterOptions("name", this.customers);
        this.customerCurrentPage = requestedPage;
        this.customerTotalPages =
          Number(data?.totalPages) ||
          Math.ceil((Number(data?.totalRows) || 0) / this.customerPerPage);
        this.customerHasNextPage =
          requestedPage < this.customerTotalPages ||
          customers.length === this.customerPerPage;
      } catch (error) {
        console.error("Error loading customers:", error.message);
        if (requestVersion === this.customerRequestVersion) {
          this.customerHasNextPage = false;
        }
      } finally {
        if (requestVersion === this.customerRequestVersion) {
          this.customerLoading = false;
        }
      }
    },

    loadMoreCustomers() {
      return this.loadCustomers();
    },

    searchCustomers(query) {
      this.customerSearch = String(query || "").trim();
      return this.loadCustomers({ reset: true });
    },

    loadRecurrency() {
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,cb709850-b958-4596-9be9-1d76aacd1950`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          const data = _.get(resp, "data") || [];
          this.listRecurrency = data.listOfItems.items;
        })
        .catch((error) => {
          this.alertToast("danger", error.message);
        });
    },

    loadStatus() {
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,4018795c-bd02-44a5-b2b9-494cdf6bc6c9`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          stopLoading();
          const data = _.get(resp, "data.listOfItems") || [];
          this.statusAppintments = data.items;
          this.allStatus = data.items.filter(
            (item) => item.name.toLowerCase() !== "programada",
          );
        })
        .catch((error) => {
          stopLoading();
        });
    },

    async loadProducts({ reset = false } = {}) {
      if (!this.companyGuid || (!reset && (this.productLoading || !this.productHasNextPage))) {
        return;
      }

      if (reset) {
        this.productCurrentPage = 0;
        this.productHasNextPage = true;
        this.products.splice(0, this.products.length);
      }

      const requestedPage = reset ? 1 : this.productCurrentPage + 1;
      const requestVersion = ++this.productRequestVersion;
      const requestCompanyGuid = this.companyGuid;
      const requestSearch = this.productSearch;
      this.productLoading = true;

      try {
        const params = [
          `page,${requestedPage}`,
          `rows,${this.productPerPage}`,
          "active,true",
          `guidCompany,${requestCompanyGuid}`,
        ];
        if (requestSearch) params.push(`name,${requestSearch}`);

        const response = await allProducts(getParamsAll(params));
        if (
          requestVersion !== this.productRequestVersion ||
          requestCompanyGuid !== this.companyGuid ||
          requestSearch !== this.productSearch
        ) return;

        const data = _.get(response, "data");
        const items = Array.isArray(data?.items) ? data.items : [];
        const products = items.map((item) => ({
          label: item.name || String(item.guid),
          name: undefined,
          value: item.guid,
        }));

        if (reset) {
          this.products.splice(0, this.products.length, ...products);
        } else {
          products.forEach((option) => {
            if (!this.products.some((item) => this.sameIdentifier(item.value, option.value))) {
              this.products.push(option);
            }
          });
        }
        this.updateFilterOptions("guidProduct", this.products);
        this.productCurrentPage = requestedPage;
        this.productTotalPages =
          Number(data?.totalPages) ||
          Math.ceil((Number(data?.totalRows) || 0) / this.productPerPage);
        this.productHasNextPage =
          requestedPage < this.productTotalPages ||
          products.length === this.productPerPage;
      } catch (error) {
        console.error("Error loading products:", error.message);
        if (requestVersion === this.productRequestVersion) {
          this.productHasNextPage = false;
        }
        this.alertToast(
          "danger",
          "Error",
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        if (requestVersion === this.productRequestVersion) {
          this.productLoading = false;
        }
      }
    },

    loadMoreProducts() {
      return this.loadProducts();
    },

    searchProducts(query) {
      this.productSearch = String(query || "").trim();
      return this.loadProducts({ reset: true });
    },

    sameIdentifier(firstValue, secondValue) {
      if (firstValue == null || secondValue == null) {
        return firstValue === secondValue;
      }
      return (
        String(firstValue).trim().toLowerCase() ===
        String(secondValue).trim().toLowerCase()
      );
    },

    updateFilterOptions(fieldName, options) {
      this.fildsToFilters.forEach((field) => {
        if (field.name === fieldName) field.options = options;
      });
    },

    buildCustomerOption(client) {
      const label =
        `${client.name || ""} ${client.lastName || ""}`.trim() ||
        client.phoneNumber ||
        String(client.idClient);
      return {
        label,
        value: label,
        name: undefined,
        idClient: client.idClient,
        phoneNumber: client.phoneNumber || "",
        email: client.email || "",
      };
    },

    ensureEmployeeOption(employee, idEmployee) {
      if (idEmployee == null) return null;
      const current = this.employees.find((item) =>
        this.sameIdentifier(item.value, idEmployee),
      );
      if (current) return current;
      const option = {
        label: employee?.name || String(idEmployee),
        name: undefined,
        value: idEmployee,
      };
      this.employees.push(option);
      this.updateFilterOptions("idEmployee", this.employees);
      return option;
    },

    ensureProductOption(product, guidProduct) {
      if (!guidProduct) return null;
      const current = this.products.find((item) =>
        this.sameIdentifier(item.value, guidProduct),
      );
      if (current) return current;
      const option = {
        label: product?.name || String(guidProduct),
        name: undefined,
        value: guidProduct,
      };
      this.products.push(option);
      this.updateFilterOptions("guidProduct", this.products);
      return option;
    },

    ensureCustomerOption(client) {
      if (client.idClient == null) return null;
      const current = this.customers.find((item) =>
        this.sameIdentifier(item.idClient, client.idClient),
      );
      if (current) return current;
      const option = this.buildCustomerOption(client);
      this.customers.push(option);
      this.updateFilterOptions("name", this.customers);
      return option;
    },

    async ensureAppointmentSelectOptions(appointment) {
      const requests = [];

      if (
        appointment.guidProduct &&
        !this.products.some((item) =>
          this.sameIdentifier(item.value, appointment.guidProduct),
        )
      ) {
        if (appointment.product?.name) {
          this.ensureProductOption(appointment.product, appointment.guidProduct);
        } else {
          requests.push(
            getProduct(appointment.guidProduct)
              .then((response) => {
                const product = _.get(response, "data");
                if (product) {
                  appointment.product = product;
                  this.ensureProductOption(product, appointment.guidProduct);
                }
              })
              .catch((error) =>
                console.error("Error loading appointment product:", error.message),
              ),
          );
        }
      }

      if (
        appointment.idEmployee != null &&
        !this.employees.some((item) =>
          this.sameIdentifier(item.value, appointment.idEmployee),
        )
      ) {
        if (appointment.employee?.name) {
          this.ensureEmployeeOption(appointment.employee, appointment.idEmployee);
        } else {
          requests.push(
            getEmployee(appointment.idEmployee)
              .then((response) => {
                const employee = _.get(response, "data");
                if (employee) {
                  appointment.employee = employee;
                  this.ensureEmployeeOption(employee, appointment.idEmployee);
                }
              })
              .catch((error) =>
                console.error("Error loading appointment employee:", error.message),
              ),
          );
        }
      }

      const clients = Array.isArray(appointment.clients)
        ? appointment.clients
        : [];
      clients.forEach((client) => {
        if (client.idClient == null) return;
        if (client.name || client.lastName) {
          this.ensureCustomerOption(client);
          return;
        }
        requests.push(
          getClient(client.idClient)
            .then((response) => {
              const completeClient = _.get(response, "data");
              if (completeClient) {
                Object.assign(client, completeClient);
                this.ensureCustomerOption(completeClient);
              }
            })
            .catch((error) =>
              console.error("Error loading appointment client:", error.message),
            ),
        );
      });

      await Promise.all(requests);
    },

    handleFilterSelectSearch({ fieldName, value }) {
      if (fieldName === "name") return this.searchCustomers(value);
      if (fieldName === "guidProduct") return this.searchProducts(value);
      if (fieldName === "idEmployee") return this.searchEmployees(value);
      return Promise.resolve();
    },

    async handleFilterSelectLoadMore({ fieldName, done }) {
      if (fieldName === "name") await this.loadMoreCustomers();
      if (fieldName === "guidProduct") await this.loadMoreProducts();
      if (fieldName === "idEmployee") await this.loadMoreEmployees();
      if (typeof done === "function") done();
    },

    onShow(appointment) {
      const appointmentDetails = [
        {
          label: this.$t(this.labelForm("dse")),
          value: appointment.productAppoimnet
            ? appointment.productAppoimnet.name
            : "",
        },
        {
          label: this.$t(this.labelForm("appointmentDate")),
          value: this.formatDate(appointment.appointmentDate),
        },
        {
          label: this.$t(this.labelForm("from")),
          value: this.formatTime(appointment.appointmentDate),
        },
        {
          label: this.$t(this.labelForm("to")),
          value: this.formatTime(appointment.endDateTime),
        },
        {
          label: this.$t(this.labelForm("client")),
          value:
            Array.isArray(appointment.clients) && appointment.clients.length
              ? appointment.clients
                  .map((client) => this.getClientFullName(client))
                  .join(", ")
              : "",
        },
        {
          label: this.$t(this.labelForm("attendedby")),
          value: appointment.employee ? appointment.employee : "",
        },
        {
          label: this.$t(this.labelForm("contact")),
          value: appointment.contactDetails ? appointment.contactDetails : "",
        },
        {
          label: this.$t(this.labelForm("status")),
          value: appointment.previousStatusName,
        },
        {
          label: this.$t(this.labelForm("notes")),
          value: appointment.notes ? appointment.notes : "",
        },
      ];
      const filteredDetails = appointmentDetails.filter(
        (detail) => detail.value,
      );

      const htmlContent = `
        <div class="sweet-appointment-details">
          ${filteredDetails
            .map(
              (detail) => `
            <span class="font-weight-bolder">${detail.label}:</span> ${detail.value} <br/>
          `,
            )
            .join("")}
        </div>
      `;

      this.$swal({
        title: `<span class="sweet-title">Resumen de la cita</span>`,
        html: htmlContent,
        showConfirmButton: true,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText:
          appointment.idCatStatus == 101 || appointment.idCatStatus == 102
            ? "Editar"
            : "Detalle",
        denyButtonText: "Eliminar",
        cancelButtonText: "Cerrar",
        focusConfirm: false,
        customClass: {
          container: "sweet-appointment-container",
          popup: "sweet-appointment-popup",
          header: "sweet-appointment-header",
          title: "sweet-appointment-title",
          htmlContainer: "sweet-appointment-content",
          actions: "sweet-appointment-actions",
          confirmButton: "btn btn-primary sweet-btn sweet-btn-confirm",
          denyButton: "btn btn-danger sweet-btn sweet-btn-deny",
          cancelButton: "btn btn-outline-secondary sweet-btn sweet-btn-cancel",
        },
        buttonsStyling: false,
        allowOutsideClick: true,
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
        preConfirm: () => {
          if (
            appointment.idCatStatus == 101 ||
            appointment.idCatStatus == 102
          ) {
            this.options = 3;
            this.isEditing = true;
            this.showModal = true;
          }
          if (
            appointment.idCatStatus == 103 ||
            appointment.idCatStatus == 104
          ) {
            this.options = 2;
            this.isEditing = false;
            this.showModal = true;
          }
          return;
        },
      }).then((result) => {
        if (result.isDenied) {
          this.onDelete(appointment.idAppointment);
        }
      });
    },

    onDelete(guid, afterDelete = null) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteAppointmentProduct(guid)
            .then(async () => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.setupCalendar();
              if (typeof afterDelete === "function") {
                await afterDelete();
              }
            })
            .catch((error) => {
              stopLoading();
              console.log("error", error.message);
              this.alertToast(
                "danger",
                "Error",
                error.message,
                "AlertTriangleIcon",
              );
              this.refetchEvents();
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    formatTime(dateString) {
      return moment(dateString).format("hh:mm A");
    },

    getClientFullName(client) {
      return `${client.label}`;
    },

    async updateAppointment(startDate, appointment) {
      try {
        const momentObj = moment(startDate);

        if (!momentObj.isValid()) {
          console.error("Fecha/hora inválida:", startDate);
          return null;
        }

        const appointmentDateUtc = momentObj.format(
          "YYYY-MM-DDTHH:mm:ss.000[Z]",
        );
        const data = {
          idAppointment: appointment.idAppointment,
          appointmentDate: appointmentDateUtc,
          guidProduct: appointment.guidProduct,
          idCatStatus: appointment.idCatStatus,
          idEmployee: appointment.idEmployee,
          notes: appointment.notes,
          clients: appointment.clients,
          contactDetails: appointment.contactDetails,
        };

        createOrEditAppointmentProduct(data, appointment.idAppointment)
          .then(() => {
            this.setupCalendar();
            this.refetchEvents();
          })
          .catch((error) => {
            console.log("error", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
      }
    },

    chargeParams(start, end) {
      const arrParams = [];

      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);

      if (this.appliedFilters.date) {
        const [startDateStr, endDateStr] =
          this.appliedFilters.date.split(" to ");

        const startMoment = moment(startDateStr).startOf("day");
        const endMoment = moment(endDateStr).startOf("day");

        const formattedStart = startMoment.format("YYYY-MM-DD HH:mm:ss");
        const formattedEnd = endMoment.format("YYYY-MM-DD HH:mm:ss");

        arrParams.push(`startDateTime,${formattedStart}`);
        arrParams.push(`endDateTime,${formattedEnd}`);
      } else {
        const weekRange = this.getCalendarWeekRange(start);
        arrParams.push(
          `startDateTime,${moment(weekRange.start).format(
            "YYYY-MM-DD HH:mm:ss",
          )}`,
        );
        arrParams.push(
          `endDateTime,${moment(weekRange.end).format("YYYY-MM-DD HH:mm:ss")}`,
        );
      }

      if (this.appliedFilters.idEmployee) {
        arrParams.push(`idEmployee,${this.appliedFilters.idEmployee}`);
      }

      if (this.appliedFilters.guidProduct) {
        arrParams.push(`guidProduct,${this.appliedFilters.guidProduct}`);
      }

      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }

      return getParamsAll(arrParams);
    },

    label(field) {
      return `pages.productAppointments.table.${field}`;
    },

    labelForm(field) {
      return `pages.productAppointments.form.label.${field}`;
    },

    getUpcomingClientOptionKey(option) {
      return option && option.idClient != null
        ? String(option.idClient)
        : option?.label;
    },

    async onOpenUpcomingClients() {
      this.upcomingCustomerSelectOpen = true;
      await this.observeUpcomingClientLoader();
    },

    onCloseUpcomingClients() {
      this.upcomingCustomerSelectOpen = false;
      clearTimeout(this.upcomingCustomerSearchTimer);
      if (this.upcomingCustomerObserver) {
        this.upcomingCustomerObserver.disconnect();
      }
    },

    onSearchUpcomingClients(query) {
      clearTimeout(this.upcomingCustomerSearchTimer);
      this.upcomingCustomerSearchTimer = setTimeout(async () => {
        await this.searchCustomers(query);
        await this.observeUpcomingClientLoader();
      }, 300);
    },

    async observeUpcomingClientLoader() {
      if (
        !this.upcomingCustomerSelectOpen ||
        !this.upcomingCustomerObserver ||
        !this.customerHasNextPage
      ) return;

      await this.$nextTick();
      if (this.$refs.loadUpcomingClients) {
        this.upcomingCustomerObserver.disconnect();
        this.upcomingCustomerObserver.observe(this.$refs.loadUpcomingClients);
      }
    },

    async infiniteScrollUpcomingClients([{ isIntersecting, target }]) {
      if (!isIntersecting || this.customerLoading || !this.customerHasNextPage) {
        return;
      }
      const list = target.offsetParent;
      const scrollTop = list ? list.scrollTop : 0;
      await this.loadMoreCustomers();
      await this.$nextTick();
      if (list) list.scrollTop = scrollTop;
      await this.observeUpcomingClientLoader();
    },

    async loadUpcomingClientAppointments() {
      const client = this.selectedUpcomingClient;
      if (!this.companyGuid || !client || client.idClient == null) return;

      const requestCompanyGuid = this.companyGuid;
      const requestClientId = client.idClient;
      const rangeStart = moment();
      const rangeEnd = moment().add(3, "months").endOf("day");

      this.upcomingRangeStart = rangeStart.toDate();
      this.upcomingRangeEnd = rangeEnd.toDate();
      this.upcomingAppointments = [];
      this.upcomingAppointmentsLoading = true;
      this.showUpcomingAppointmentsModal = true;

      try {
        const params = getParamsAll([
          `guidCompany,${requestCompanyGuid}`,
          "page,1",
          `rows,${this.perPage}`,
          `startDateTime,${rangeStart.format("YYYY-MM-DD HH:mm:ss")}`,
          `endDateTime,${rangeEnd.format("YYYY-MM-DD HH:mm:ss")}`,
          `name,${client.label}`,
        ]);
        const response = await allAppointmentsProducts(params);

        if (
          requestCompanyGuid !== this.companyGuid ||
          !this.selectedUpcomingClient ||
          !this.sameIdentifier(
            this.selectedUpcomingClient.idClient,
            requestClientId,
          )
        ) return;

        const data = _.get(response, "data");
        const items = Array.isArray(data?.items) ? data.items : [];
        this.upcomingAppointments = items
          .filter((appointment) => {
            const clients = Array.isArray(appointment.clients)
              ? appointment.clients
              : [];
            const date = moment(appointment.appointmentDate);
            return (
              date.isValid() &&
              date.isBetween(rangeStart, rangeEnd, undefined, "[]") &&
              clients.some((item) =>
                this.sameIdentifier(item.idClient, requestClientId),
              )
            );
          })
          .sort(
            (first, second) =>
              new Date(first.appointmentDate) -
              new Date(second.appointmentDate),
          );
      } catch (error) {
        console.error(
          "Error loading upcoming product appointments:",
          error.message,
        );
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        this.showUpcomingAppointmentsModal = false;
      } finally {
        if (
          requestCompanyGuid === this.companyGuid &&
          this.selectedUpcomingClient &&
          this.sameIdentifier(
            this.selectedUpcomingClient.idClient,
            requestClientId,
          )
        ) {
          this.upcomingAppointmentsLoading = false;
        }
      }
    },

    editUpcomingAppointment(appointment) {
      if (!this.canEdit || !appointment?.idAppointment) return;
      this.showUpcomingAppointmentsModal = false;
      this.showAppointment(appointment.idAppointment, { directEdit: true });
    },

    deleteUpcomingAppointment(appointment) {
      if (!this.canDelete || !appointment?.idAppointment) return;
      this.onDelete(appointment.idAppointment, () => {
        this.upcomingAppointments = this.upcomingAppointments.filter(
          (item) =>
            !this.sameIdentifier(
              item.idAppointment,
              appointment.idAppointment,
            ),
        );
      });
    },

    resetTenantData() {
      this.appliedFilters = {};
      this.employeeSearch = "";
      this.employeeCurrentPage = 0;
      this.employeeTotalPages = 0;
      this.employeeHasNextPage = Boolean(this.companyGuid);
      this.employeeLoading = false;
      this.employeeRequestVersion += 1;
      this.employees = [];
      this.updateFilterOptions("idEmployee", []);
      this.productSearch = "";
      this.productCurrentPage = 0;
      this.productTotalPages = 0;
      this.productHasNextPage = Boolean(this.companyGuid);
      this.productLoading = false;
      this.productRequestVersion += 1;
      this.products = [];
      this.updateFilterOptions("guidProduct", []);
      this.customerSearch = "";
      this.customerCurrentPage = 0;
      this.customerTotalPages = 0;
      this.customerHasNextPage = Boolean(this.companyGuid);
      this.customerLoading = false;
      this.customerRequestVersion += 1;
      this.customers = [];
      this.updateFilterOptions("name", []);
      this.selectedUpcomingClient = null;
      this.upcomingAppointments = [];
      this.upcomingAppointmentsLoading = false;
      this.showUpcomingAppointmentsModal = false;
      clearTimeout(this.upcomingCustomerSearchTimer);
      if (this.upcomingCustomerObserver) {
        this.upcomingCustomerObserver.disconnect();
      }
    },

    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        if (filters.date) {
          const [startDateStr, endDateStr] = filters.date.split(" to ");
          const start = moment(startDateStr).toDate();
          const end = moment(endDateStr).toDate();

          if (this.$refs.calendar) {
            const calendarApi = this.$refs.calendar.getApi();
            calendarApi.gotoDate(start);
            calendarApi.changeView(this.currentView, {
              start: start,
              end: end,
            });
          }
        }
        this.refetchEvents();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },

    validateFilters(filters) {
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }
      if (
        filters.idEmployee &&
        !this.employees.some((cond) => cond.value === filters.idEmployee)
      ) {
        console.error("El filtro de condición no es válido.");
        return false;
      }

      if (
        filters.guidProduct &&
        !this.products.some((item) =>
          this.sameIdentifier(item.value, filters.guidProduct),
        )
      ) {
        console.error("El filtro de producto no es válido.");
        return false;
      }

      if (filters.date) {
        const [start, end] = filters.date.split(" to ");
        if (
          !moment(start, "YYYY-MM-DD", true).isValid() ||
          !moment(end, "YYYY-MM-DD", true).isValid()
        ) {
          console.error("Formato de fecha inválido");
          return false;
        }
      }

      return true;
    },

    resetFilters() {
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.setupCalendar();
      if (this.$refs.calendar) {
        const calendarApi = this.$refs.calendar.getApi();
        calendarApi.today();
      }
    },

    formatToUtcIso(dateStr, timeStr) {
      let timePart = timeStr.trim();

      if (!timePart.includes(":")) {
        timePart = timePart.padStart(2, "0") + ":00:00";
      } else {
        const parts = timePart.split(":");
        if (parts.length === 2) {
          timePart =
            parts[0].padStart(2, "0") + ":" + parts[1].padStart(2, "0") + ":00";
        } else if (parts.length === 3) {
          timePart =
            parts[0].padStart(2, "0") +
            ":" +
            parts[1].padStart(2, "0") +
            ":" +
            parts[2].padStart(2, "0");
        }
      }

      const fullDateTime = `${dateStr} ${timePart}`;
      const momentObj = moment.utc(fullDateTime, "YYYY-MM-DD HH:mm:ss", true); // <- utc aquí

      if (!momentObj.isValid()) {
        console.error("Fecha/hora inválida:", dateStr, timeStr);
        return null;
      }

      return momentObj.format("YYYY-MM-DDTHH:mm:ss.000[Z]");
    },

    onCreate() {
      this.currentEvent = {
        idAppointment: null,
        guidProduct: null,
        appointmentDate: "",
        durationMinutes: null,
        clients: [],
        idEmployee: null,
        idCatStatus: null,
        contactDetails: "",
        notes: null,
        isRecurring: false,
        idCatRecurrencePattern: null,
        endDateTime: "",

        appointmentTimeStar: "",
        appointmentTimeEnd: "",
        payments: [],
      };
      this.isEditing = false;
      this.showModal = true;
      this.options = 1;
    },

    onCancel() {
      this.currentEvent = Object.assign({
        idAppointment: null,
        guidProduct: null,
        appointmentDate: "",
        durationMinutes: null,
        clients: [],
        idEmployee: null,
        idCatStatus: null,
        contactDetails: "",
        notes: null,
        isRecurring: false,
        idCatRecurrencePattern: null,
        endDateTime: "",
      });
    },

    onInfo() {
      console.log("Displaying tutorial info");
    },

    getEmployeeColor(idEmployee) {
      if (!idEmployee && idEmployee !== 0) return "#cccccc";

      if (!this.employeeColors[idEmployee]) {
        const colors = [
          "#FFCDD2",
          "#F8BBD0",
          "#E1BEE7",
          "#D1C4E9",
          "#C5CAE9",
          "#BBDEFB",
          "#B3E5FC",
          "#B2EBF2",
          "#B2DFDB",
          "#C8E6C9",
          "#DCEDC8",
          "#F0F4C3",
          "#FFECB3",
          "#FFE0B2",
          "#FFCCBC",
          "#D7CCC8",
          "#CFD8DC",
          "#F5F5F5",
          "#E0F7FA",
          "#FFF3E0",
        ];
        const colorIndex = Math.abs(Number(idEmployee)) % colors.length;
        this.$set(this.employeeColors, idEmployee, colors[colorIndex]);
      }
      return this.employeeColors[idEmployee];
    },

    alertToast(type = null, title = null, message = null) {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title,
          icon:
            type == "danger"
              ? "XIcon"
              : type == "success"
              ? "CheckIcon"
              : "AlertTriangleIcon",
          variant: type,
          text: message,
        },
      });
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },

    getHeaderToolbar() {
      return {
        start: "prev,next, title",
        end: this.headerViews,
      };
    },

    handleResize() {
      this.checkMobile();
      this.calendarOptions.headerToolbar = this.getHeaderToolbar();
      this.calendarOptions.initialView = this.initialView;
      this.$refs["calendar"].getApi().updateSize();
    },

    onDateClick(info) {
      // this.currentEvent = {
      //   id: null,
      //   title: '',
      //   start: info.date,
      //   end: new Date(info.date.getTime() + 30 * 60 * 1000),
      //   idEmployee: this.employees[0]?.id || null,
      //   notes: '',
      //   client: ''
      // }
      // console.log('onDateClick', info)
      // this.isEditing = false
      // this.showModal = true
    },

    onSelect(info) {
      this.currentEvent = {
        id: null,
        title: "",
        start: info.start,
        end: info.end,
        idEmployee: this.employees[0]?.id || null,
        notes: "",
        client: "",
      };
      // this.isEditing = false
      // this.showModal = true
    },

    onEventClick(info) {
      const e = info.event;
      if (e.extendedProps.idAppointment) {
        this.showAppointment(e.extendedProps.idAppointment);
      }
    },

    onEventDrop(info) {
      const e = info.event;
      const idx = this.appointments.findIndex(
        (ev) => ev.idAppointment == e.extendedProps.idAppointment,
      );
      if (idx === -1) {
        info.revert();
        return;
      }
      const oldStart = info.oldEvent.start;
      const newStart = e.start;

      locale("es");
      const formattedOld = moment(oldStart).format("dddd D MMMM YYYY HH:mm A");
      const formattedNew = moment(newStart).format("dddd D MMMM YYYY HH:mm A");

      this.appointments[idx].start = e.start;
      this.appointments[idx].end = e.end;

      const data = {
        idAppointment: this.appointments[idx].idAppointment,
        guidProduct: this.appointments[idx].guidProduct,
        idCatStatus: this.appointments[idx].idCatStatus,
        idEmployee: this.appointments[idx].idEmployee,
        notes: this.appointments[idx].notes,
        contactDetails: this.appointments[idx].contactDetails,
        clients: this.appointments[idx].extendedProps.clientsList,
      };

      this.$swal({
        title: "¿Estás seguro?",
        text: `¿Deseas mover la cita de ${formattedOld} a ${formattedNew}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, moverla",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.updateAppointment(e.start, data);
        } else if (result.dismiss === "cancel") {
          info.revert();
          this.message(this.$t("canceled"), "No se movió la cita", "error");
          return;
        }
      });
    },

    onEventResize(info) {
      const e = info.event;
      const idx = this.appointments.findIndex((ev) => ev.id == e.id);
      if (idx > -1) this.appointments[idx].end = e.end;
      // TODO: llamar API PATCH
    },

    async saveEvent(info, catStatus) {
      showLoading();
      try {
        const baseDate = info.appointmentDate.split("T")[0];
        const { appointmentTimeStar } = info;

        const clients = info.clients.map((idCli) => ({
          idClient: idCli.idClient || idCli,
        }));
        // guidService
        const data = {
          idAppointment: info.idAppointment,
          guidProduct: info.guidProduct,
          appointmentDate: this.formatToUtcIso(baseDate, appointmentTimeStar),
          durationMinutes: info.durationMinutes,
          clients: clients || [],
          idEmployee: info.idEmployee,
          idCatStatus: catStatus,
          contactDetails: info.contactDetails,
          notes: info.notes,
          isRecurring: info.isRecurring,
          idCatRecurrencePattern: info.idCatRecurrencePattern,
        };

        const idAppointment = info.idAppointment || null;

        await createOrEditAppointmentProduct(data, idAppointment);
        this.showModal = false;
        this.isEditing = false;
        this.refetchEvents();
      } catch (error) {
        console.error("Error saving event:", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        stopLoading();
      }
    },

    saveEventClient(info) {
      showLoading();
      try {
        const data = {
          idClient: info.idClient,
          guidCompany: this.companyGuid,
          name: info.name,
          lastName: info.lastName,
          dni: info.dni,
          phoneNumber: info.phoneNumber,
          email: info.email,
          address: info.address,
        };

        const idClient = null;
        createOrEditClient(data, idClient)
          .then(async () => {
            this.showModalClient = false;
            await this.setupCalendar();
            this.onCreate();
          })
          .catch((error) => {
            console.log("error", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.error("Error saving event:", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        stopLoading();
      }
    },

    resetCurrentEvent() {
      this.currentEvent = {
        id: null,
        title: "",
        notes: "",
        idEmployee: null,
        client: "",
        start: "",
        end: "",
      };
      this.showModal = false;
    },

    resetCurrentEventClient() {
      // this.currentEvent = {
      //   id: null,
      //   title: "",
      //   notes: "",
      //   idEmployee: null,
      //   client: "",
      //   start: "",
      //   end: "",
      // };
      // this.showModal = false;
      this.showModalClient = false;
    },

    getUpdatedDateMonth(date) {
      this.dateChanges = true;

      const currentDate = new Date(date);
      const firstDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1,
      );
      const lastDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0,
      );

      this.firstDay = this.dateFormatter(firstDate);
      this.lastDay = this.dateFormatter(lastDay);
    },

    dateFormatter(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },

  async created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.checkMobile();
    this.visibleRange = this.getCalendarWeekRange();
    if (this.companyGuid && this.companyGuid !== "null") {
      await this.loadInitialData();
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    clearTimeout(this.upcomingCustomerSearchTimer);
    if (this.upcomingCustomerObserver) {
      this.upcomingCustomerObserver.disconnect();
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";

.calendar-app {
  display: flex;
}

.product-upcoming-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.15rem;
  border: 1px solid #ebe9f1;
  border-radius: 0.65rem;
  background: #fff;
}

.product-upcoming-search__intro,
.product-upcoming-search__controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.product-upcoming-search__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 0.55rem;
  background: rgba(115, 103, 240, 0.1);
  color: #7367f0;
}

.product-upcoming-search__controls {
  display: grid;
  grid-template-columns: minmax(260px, 420px) auto;
  width: min(100%, 650px);
}

.product-upcoming-client-loader {
  padding: 0.65rem;
  color: #b9b9c3;
  text-align: center;
}

@media (max-width: 767.98px) {
  .product-upcoming-search {
    align-items: stretch;
    flex-direction: column;
  }

  .product-upcoming-search__controls {
    grid-template-columns: 1fr;
    width: 100%;
  }
}

.position-relative {
  position: relative;
}
.fc-event {
  transition: transform 0.2s ease;
  border-radius: 4px;
  border-width: 2px;
}

.fc-event:hover {
  transform: translateY(-2px);
  z-index: 100;
}

.fc-event-content-wrapper {
  padding: 4px;
  overflow: hidden;
}
.sweet-appointment-container {
}

.sweet-appointment-popup {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  width: 85%;
  max-width: 600px;
}

.sweet-appointment-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}

.sweet-appointment-title {
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 600;
  display: block;
  text-align: center;
  width: 100%;
}

.sweet-appointment-content {
  padding: 20px 0;
}

.sweet-appointment-details {
  position: relative;
}

.status-badge {
  position: absolute;
  top: -45px;
  right: 20px;
  padding: 8px 15px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.status-badge.programada {
  background: #3498db;
  color: white;
}
.status-badge.confirmada {
  background: #2ecc71;
  color: white;
}
.status-badge.completada {
  background: #9b59b6;
  color: white;
}
.status-badge.cancelada {
  background: #e74c3c;
  color: white;
}

.details-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 10px;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 8px;
}

.detail-label {
  font-weight: 600;
  color: #555;
  min-width: 140px;
  flex-shrink: 0;
}

.detail-value {
  color: #2c3e50;
  flex-grow: 1;
  word-break: break-word;
}

/* CONTENEDOR DE BOTONES CON ESPACIADO */
.sweet-appointment-actions {
  display: flex;
  justify-content: center;
  gap: 12px; /* Espacio uniforme entre botones */
  margin-top: 25px;
  flex-wrap: wrap; /* Para que se apilen en móviles */
}

.sweet-btn {
  border-radius: 8px;
  padding: 10px 22px;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 100px; /* Ancho mínimo para consistencia */
  margin: 4px; /* Espacio adicional para móviles */
  border: none;
  cursor: pointer;
  text-align: center;
  font-size: 0.95rem;
}

.sweet-btn-confirm {
  background: #3498db;
  color: white;
}

.sweet-btn-deny {
  background: #e74c3c;
  color: white;
}

.sweet-btn-cancel {
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
}

.sweet-btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
  background: #2980b9;
}

.sweet-btn-deny:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
  background: #c0392b;
}

.sweet-btn-cancel:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
}

/* Responsive */
@media (max-width: 576px) {
  .sweet-appointment-actions {
    flex-direction: column;
    gap: 8px;
  }

  .sweet-btn {
    width: 100%;
  }

  .detail-row {
    flex-direction: column;
    gap: 4px;
  }

  .detail-label {
    min-width: auto;
  }

  .status-badge {
    position: static;
    margin-bottom: 15px;
    text-align: center;
  }
}

.fc .fc-timegrid .fc-timegrid-slots .fc-timegrid-slot {
  height: 5rem !important;
}
</style>
